import { useQuery } from "@tanstack/react-query";
import { api } from "api";
import { useFetchStateHelper } from "hooks/useFetchState";

/**
 *
 * @param {Object} params
 * @param {string} params.cropId - optional, if not provided it will fetch all fertilizers without filtering by crop
 * @returns
 */
export const useFertilizers = ({ cropId }) => {
  const { data: fertilizers, ...queryResponse } = useQuery({
    queryKey: ["fertilizers", cropId],
    queryFn: async () => {
      const res = await api.crops.fertilizers({ cropId });
      let newFertilizers = res.data;
      if (!newFertilizers || !newFertilizers?.length) {
        const newRes = await api.crops.fertilizers();
        newFertilizers = newRes.data;
      }
      return newFertilizers;
    },
  });

  const { fetchState } = useFetchStateHelper(queryResponse);

  return { fertilizers, fetchState };
};
